import { createAction, props } from '@ngrx/store';
import { eKioskError } from 'src/app/shared/models/api/constants';
import { ErrorLevel } from '../error-level';

export const setErrorMsg = createAction(
  '[Error] Set error message',
  props<{ data: string, errorLevel?: ErrorLevel, noTranslation?: boolean, displayCountdown?: boolean, KioskError?: eKioskError }>()
);

export const resetError = createAction("[Error] Reset");